import React from 'react';
import {observer} from 'mobx-react';
import FilterComponent from 'main/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';

const ReviewQuestion = observer(({models, filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const options = models.map(question => {
    return { label:  question.name, value:  question.id};
  });

  return <FilterComponent
    filter={filter}
    filterKey={filterKey}
    options={options}
    filterUpdated={filterUpdated}
    filterDeleted={filterDeleted}
    Wrapper={Wrapper}
    searchable
  />;
});

export default ReviewQuestion;
